<!-- Page Header End -->
<app-pageheader [pageOptions]="pageOptions"></app-pageheader>
<!-- Page Header End -->

<!-- Page content start -->
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="container">
    <!-- Main Page Start -->
    <div class="row g-5 align-items-center">
      <div class="col-lg-12 wow fadeInUp" data-wow-delay="0.1s">
        <h1 class="mb-4">
          {{ FR_LIBRARY.title[this.language] }}
        </h1>
        <img
          width="700"
          src="../../../../../../assets/img/{{ FR_LIBRARY.image }}"
          alt=""
          [style]="getLibraryStyleImage()"
        />
        <p [innerHtml]="FR_LIBRARY.description[this.language]"></p>
      </div>
    </div>
    <div class="row g-4">
      <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
        <a href="/academics/libraries/frLibrary#FR_LIBRARY_KG_SECTION">
          <div class="facility-item">
            <div class="facility-text bg-primary">
              <h3 class="text-primary mb-3">{{ "kg" | translate }}</h3>
              <!-- <p class="mb-0">
                Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                ipsum sit
              </p> -->
            </div>
          </div>
        </a>
      </div>

      <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
        <a href="/academics/libraries/frLibrary#FR_LIBRARY_PRIMARY_SECTION">
          <div class="facility-item">
            <div class="facility-text bg-success">
              <h3 class="text-success mb-3">{{ "primary" | translate }}</h3>
              <!-- <p class="mb-0">
                Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                ipsum sit
              </p> -->
            </div>
          </div>
        </a>
      </div>

      <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
        <a href="/academics/libraries/frLibrary#FR_LIBRARY_PREPARATORY_SECTION">
          <div class="facility-item">
            <div class="facility-text bg-warning">
              <h3 class="text-warning mb-3">
                {{ "preparatory" | translate }}
              </h3>
              <!-- <p class="mb-0">
                Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                ipsum sit
              </p> -->
            </div>
          </div>
        </a>
      </div>

      <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
        <a href="/academics/libraries/frLibrary#FR_LIBRARY_SECONDARY_SECTION">
          <div class="facility-item">
            <div class="facility-text bg-info">
              <h3 class="text-info mb-3">{{ "secondary" | translate }}</h3>
              <!-- <p class="mb-0">
                Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                ipsum sit
              </p> -->
            </div>
          </div>
        </a>
      </div>
    </div>
    <br />
    <br /><br />
    <!-- Main Page End -->

    <!-- KG Section Start -->
    <div id="FR_LIBRARY_KG_SECTION">
      <h1 class="mb-4">{{ "kg" | translate }}</h1>
      <app-articles-view
        [articles]="kgArticlesArray"
        [itemsPerPage]="3"
        [articleSection]="'FR_LIBRARY_KG_SECTION'"
        (onPaginateEvent)="onKgPaginateEvent($event)"
      ></app-articles-view>
    </div>
    <!-- KG Section End -->

    <!-- Primary Section Start -->
    <div id="FR_LIBRARY_PRIMARY_SECTION">
      <h1 class="mb-4">{{ "primary" | translate }}</h1>
      <app-articles-view
        [articles]="primaryArticlesArray"
        [itemsPerPage]="3"
        [articleSection]="'FR_LIBRARY_PRIMARY_SECTION'"
        (onPaginateEvent)="onPrimPaginateEvent($event)"
      ></app-articles-view>
    </div>
    <!-- Primary Section End -->

    <!-- Preparatory Section Start -->
    <div id="FR_LIBRARY_PREPARATORY_SECTION">
      <h1 class="mb-4">{{ "preparatory" | translate }}</h1>
      <app-articles-view
        [articles]="preparatoryArticlesArray"
        [itemsPerPage]="3"
        [articleSection]="'FR_LIBRARY_PREPARATORY_SECTION'"
        (onPaginateEvent)="onPrepPaginateEvent($event)"
      ></app-articles-view>
    </div>
    <!-- Preparatory Section End -->

    <!-- Secondary Section Start -->
    <div id="FR_LIBRARY_SECONDARY_SECTION">
      <h1 class="mb-4">{{ "secondary" | translate }}</h1>
      <app-articles-view
        [articles]="secondaryArticlesArray"
        [itemsPerPage]="3"
        [articleSection]="'FR_LIBRARY_SECONDARY_SECTION'"
        (onPaginateEvent)="onSecPaginateEvent($event)"
      ></app-articles-view>
    </div>
    <!-- Secondary Section End -->
  </div>
</div>
<!-- Page content end -->
